import {RowDataProps} from '../../components/props/tables';
import type {
  GroupsMembership, GroupsForm, GroupsLayer, GroupsProject
} from '../../models/group';

export const searchSortHeaderStyles = {
  width: ['100%', 320],
  mt: 3,
  mb: 3,
  alignItems: 'center',
}

export const groupMembers: GroupsMembership[] = [
  {
    id: '1',
    user: 'Jhon Doe',
    email: 'jhon.doe@example.com',
    avatar: '',
    description: 'Owner  |  jhon.doe@example.com',
  },
  {
    id: '2',
    user: 'Jane Doe',
    email: 'jane.doe@example.com',
    avatar: '',
    description: 'Manager  |  jane.doe@example.com',
  },
];

export const groupApps: GroupsForm[] = [
  { id: 'id1', name: 'app1', record_count: 10, updated_at: new Date().toISOString(), image: ''  },
  { id: 'id2', name: 'app2', record_count: 12, updated_at: new Date().toISOString(), image: '' },
]
export const groupLayers: GroupsLayer[] = [
  { id: 'id1', name: 'MapLayer1', description: 'desc1', type: 'fulcrum', image: '' },
  { id: 'id2', name: 'MapLayer2', description: 'desc2', type: 'fulcrum', image: '' },
]
export const groupProjects: GroupsProject[] = [
  { id: 'id1', name: 'app1', record_count: '10', form_count: '5', image: '' },
  { id: 'id2', name: 'app2', record_count: '12', form_count: '6', image: '' },
]

export const emptyGroupsText =
    'Use Groups to manage Member access to Apps, Projects, and Map Layers';

export const emptyGroupMembersText =
    'Add members to manage their access.';

const groups: RowDataProps[] = [
    {
        name: 'Electrical',
        description: 'test electrical group',
        id: '7ecbefda-74f1-4fbd-b421-f4e1e417a47f',
        isManaged: false,
        layerIds: [],
        projectIds: [],
        formIds: [],
    },
    {
        name: 'Construction',
        description: 'test construction group',
        id: 'ecf76ff8-cfdd-4ac8-afd6-295bd218a6e4',
        isManaged: false,
        layerIds: [],
        projectIds: [],
        formIds: [],
    },
];


export default groups;
